/**
 * Record how far `transformNodeChanges` (e.g. helper-line snapping) moved each
 * in-drag position change off react-flow's raw pointer-derived position. The
 * live lane layout re-derives dragged positions from pointer-anchored targets
 * (see `applyLiveDragLaneLayout`), which would silently discard the snap —
 * `onNodeDrag` adds these offsets back so the snapped position survives the
 * lane pass. Offsets are parent-relative deltas, which equal absolute deltas
 * (same parent frame), so they compose directly with absolute targets.
 *
 * Only frames with `dragging: true` are recorded: `onNodeDrag` never fires
 * after the final mouseup frame (`dragging: false`), so an offset recorded
 * there could never be consumed — drop snapping survives via
 * `applyNodeChanges` plus the updater-form settle in `onNodeDragStop`.
 */ export function recordSnapOffsets(raw, transformed, offsets) {
    const rawById = new Map();
    for (const c of raw){
        if (c.type === "position" && c.dragging === true && c.position) {
            rawById.set(c.id, c.position);
        }
    }
    for (const c of transformed){
        if (c.type !== "position" || c.dragging !== true || !c.position) continue;
        const rawPos = rawById.get(c.id);
        if (!rawPos) continue;
        const dx = c.position.x - rawPos.x;
        const dy = c.position.y - rawPos.y;
        if (dx === 0 && dy === 0) offsets.delete(c.id);
        else offsets.set(c.id, {
            x: dx,
            y: dy
        });
    }
}

//# sourceMappingURL=recordSnapOffsets.js.map